import { 
  IconLibraryPlusFilled, 
  IconTable, 
  IconBusinessplan, 
  IconFile, 
  IconBook, 
  IconDeviceLaptop,
  IconCalendar,
  IconShield,
  IconMail,
  IconSend,
  IconInbox,
  IconHelpCircle,
  IconDeviceMobile,
  IconVideo,
  IconWorld,
  IconLayersIntersect,
  IconUser,
  IconPackage,
  IconFileText,
  IconAlertTriangle,
  IconClock,
  IconFileExport,
  IconFileSpreadsheet,
  IconFileCheck,
  IconTool,
  IconChartBar,
  IconFilter,
  IconFilePlus,
  IconUserCog,
  IconLifebuoy,
  IconTruck,
  IconTree,
  IconTrash
} from "@tabler/icons-react";
import { SidebarNavigation } from "./_types";

export const sidebarNavigation: SidebarNavigation = {
  preNotas: [
    {
      label: "Adicionar Nota",
      href: "/prenotas/inclusao",
      icon: IconLibraryPlusFilled,
    },
    {
      label: "Tabela de Pré-Notas",
      href: "/prenotas",
      icon: IconTable,
    }
  ],
  
  financeiro: [
    {
      label: "Faturas",
      href: "/financeiro",
      icon: IconBusinessplan,
    },
  ],
  
  documentacao: [
    {
      label: "TI",
      icon: IconDeviceLaptop,
      subItems: [
        {
          label: "Agendar Reunião",
          href: "/documentacao/ti/agendamentoreuniao",
          icon: IconCalendar,
        },
        {
          label: "Anti-ameaças",
          href: "/documentacao/ti/antiameacas",
          icon: IconShield,
        },
        {
          label: "Assinaturas",
          href: "/documentacao/ti/assinaturaemail",
          icon: IconMail,
        },
        {
          label: "E-mail automático",
          href: "/documentacao/ti/emailautomatico",
          icon: IconSend,
        },
        {
          label: "E-mails limitados",
          href: "/documentacao/ti/emaillimitado",
          icon: IconInbox,
        },
        {
          label: "Gmail Dicas",
          href: "/documentacao/ti/gmaildicas",
          icon: IconHelpCircle,
        },
        {
          label: "Gmail no Celular",
          href: "/documentacao/ti/gmailcelular",
          icon: IconDeviceMobile,
        },
        {
          label: "Google Meet",
          href: "/documentacao/ti/googlemeet",
          icon: IconVideo,
        },
        { 
          label: "Proxy", 
          href: "/documentacao/ti/proxy", 
          icon: IconWorld 
        },
      ],
    },
    {
      label: "Protheus",
      icon: IconFile,
      subItems: [
        {
          label: "Agrupados",
          href: "/documentacao/protheus/agrupados",
          icon: IconLayersIntersect,
        },
        {
          label: "Alterar Cliente",
          href: "/documentacao/protheus/alterarcliente",
          icon: IconUser,
        },
        {
          label: "Cadastro de KIT",
          href: "/documentacao/protheus/cadastrokit",
          icon: IconPackage,
        },
        {
          label: "Contabilidade",
          href: "/documentacao/protheus/contabilidade",
          icon: IconBook,
        },
        {
          label: "Contabilização",
          href: "/documentacao/protheus/contabilizacao",
          icon: IconFileText,
        },
        {
          label: "Dicas Úteis",
          href: "/documentacao/protheus/dicasuteis",
          icon: IconHelpCircle,
        },
        {
          label: "Erro Transmissão",
          href: "/documentacao/protheus/errotransmitirnota",
          icon: IconAlertTriangle,
        },
        {
          label: "Escala Produtivo",
          href: "/documentacao/protheus/escalaprodutivo",
          icon: IconClock,
        },
        {
          label: "Exportar XML",
          href: "/documentacao/protheus/exportarxml",
          icon: IconFileExport,
        },
        { 
          label: "GNRE", 
          href: "/documentacao/protheus/gnre", 
          icon: IconFile 
        },
        {
          label: "Kardex",
          href: "/documentacao/protheus/kardex",
          icon: IconFileSpreadsheet,
        },
        {
          label: "Pré-Nota",
          href: "/documentacao/protheus/liberacaoprenota",
          icon: IconFileCheck,
        },
        {
          label: "Ordem de Serviço",
          href: "/documentacao/protheus/os",
          icon: IconTool,
        },
        {
          label: "Saldo de Itens",
          href: "/documentacao/protheus/saldoitens",
          icon: IconPackage,
        },
        {
          label: "Treinamento DMS",
          href: "/documentacao/protheus/treinamentodms",
          icon: IconBook,
        },
        {
          label: "Valor Informado",
          href: "/documentacao/protheus/valorinformado",
          icon: IconFileText,
        },
        {
          label: "Venda de Peças",
          href: "/documentacao/protheus/vendapecas",
          icon: IconPackage,
        },
      ],
    },
    {
      label: "Power BI",
      icon: IconChartBar,
      subItems: [
        { 
          label: "Acessar", 
          href: "/documentacao/powerbi/acesso", 
          icon: IconWorld 
        },
        { 
          label: "Como utilizar", 
          href: "/documentacao/powerbi/utilizacao", 
          icon: IconHelpCircle 
        },
        { 
          label: "Exportar dados", 
          href: "/documentacao/powerbi/exportacao", 
          icon: IconFileExport 
        },
        { 
          label: "Filtros", 
          href: "/documentacao/powerbi/filtros", 
          icon: IconFilter 
        },
        { 
          label: "Relatórios", 
          href: "/documentacao/powerbi/relatorios", 
          icon: IconChartBar 
        },
      ],
    },
  ],
  
  corporativo: [
    { 
      label: "Suporte", 
      href: "http://hesk.rodoparana.com.br", 
      icon: IconLifebuoy 
    },
    { 
      label: "Meu RH", 
      href: "https://datasul.rodoparana.com.br/totvs-login/loginForm", 
      icon: IconUserCog 
    },
    { 
      label: "Rodoparaná", 
      href: "https://rodoparana.com.br", 
      icon: IconTruck 
    },
    { 
      label: "Timber", 
      href: "https://grupotimber.com.br", 
      icon: IconTree 
    },

  ],
  
  configuracoes: [
    {
      label: "Limpar cache",
      actionKey: "clearCache",
      icon: IconTrash,
      variant: "default",
    },
  ],
};